define('libs/smoothscroll',['require','TweenLite','TweenLiteScrollTo'],function(require) {

    'use strict';

    var TweenLite = require('TweenLite'),
        ScrollPlugin = require('TweenLiteScrollTo');

    var SETTINGS = {
        speed: 1500, // pixels per second,
        minDuration: .25,
        maxDuration: 2.5,
        relativeSpeed: true,
        offsetTop: 0,
        offsetLeft: 0,
        verticalOnly: false,
        horizontalOnly: false,
        ease: 'Power3.easeInOut'
    };

    /**
     * SmoothScroll
     * Scrolls the page with an animation instead of jumping to the new position.
     */
    var SmoothScroll = function() {
        this.init.apply(this, arguments);
    };

    /**
     * initialize the component. Set all event handlers.
     * @param {Element} element The base element for the component.
     * @param {Object} settings The settings for the component.
     */
    SmoothScroll.prototype.init = function(element, settings) {
        this.element = element;
        this.$element = $(element);
        this.$window = $(window);
        this.settings = $.extend({}, SETTINGS, settings || {});

        this.$element.click(this.onClick.bind(this));
    };

    /**
     * Find the target to scroll to..
     * @param {jQuery} element The element that triggered the scroll.
     * @return {jQuery} The target element.
     */
    SmoothScroll.prototype.getTarget = function(element) {
        var attribute = element.attr('href') || element.attr('data-scrollto');
        if (!attribute) {
            // look for parent with these attributes.
            var parent = element.closest('[href], [data-scrollto]');
            attribute = parent.attr('href') || parent.attr('data-scrollto');
        }
        if (attribute) {
            var target = attribute.match(/^#\S+/);
        }

        if (target && target[0]) {
            target = target[0];
        }

        this.target = $(target);

        return this.target;
    };

    /**
     * Handle the click on the link.
     * @param {Event} event The event that triggered the scroll action.
     */
    SmoothScroll.prototype.onClick = function(event) {
        var targetElement = this.getTarget($(event.target));
        if (targetElement[0]) {
            event.preventDefault();
            var position = this.getPosition(targetElement);
            var duration = this.getDuration(position);

            this.scroll(position, duration);
        }
    };

    /**
     * Get the position of the target
     * @param {jQuery} target The element to scroll to.
     * @return {Object} The top and left position of the target.
     */
    SmoothScroll.prototype.getPosition = function(target) {
        var position = target.offset();
        position = {
            // maximum scroll offset is document height - window height
            top: Math.min(position.top - this.settings.offsetTop, $(document).height() - this.$window.height()),
            left: position.left - this.settings.offsetLeft
        };

        return position;
    };

    /**
     * Calculate the duration of the scroll animation.
     * Longer distances take more time.
     * @param {Object} position The top and left position of the target.
     * @return {Number} The duration of the scroll animation in milliseconds.
     */
    SmoothScroll.prototype.getDuration = function(position) {

        if (!this.settings.relativeSpeed) return this.settings.speed;

        // get the current scroll offsets.
        var scrollY = this.$window.scrollTop();
        var scrollX = this.$window.scrollLeft();

        // see in what direction we have to scroll the most, horizontally or vertically.
        var distance = Math.max(Math.abs(position.top - scrollY), Math.abs(position.left - scrollX));
        var duration = distance / this.settings.speed;

        duration = Math.max(duration, this.settings.minDuration);
        duration = Math.min(duration, this.settings.maxDuration);

        return duration;
    };

    /**
     * Scroll the page to the targeted element.
     * @param {Object} position The top and left position of the target.
     * @param {Number} duration The duration of the scroll animation in milliseconds.
     */
    SmoothScroll.prototype.scroll = function(position, duration) {
        var scrollTo = {};
        if (!this.settings.verticalOnly) {
            scrollTo.x = position.left;
        }
        if (!this.settings.horizontalOnly) {
            scrollTo.y = position.top;
        }

        TweenLite.to(window, duration, {
            scrollTo: scrollTo,
            ease: this.settings.ease
        });
    };

    return SmoothScroll;

});

